var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav__tab"},[_c('li',{staticClass:"nav__tab__list__item"},[_vm._t("nav-item")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }